export function numberFormatter(num: number) {
    if (num >= 1000000000) {
        return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
    }
    if (num >= 1000000) {
        return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (num >= 1000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    return Math.round(num);
}

export function priceSplitter(number: number) {
    return number && number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
export const formatEuro = (value: number | null | undefined) => {
    if (value === null || value === undefined || isNaN(value)) {
        return '€0,00';
    }

    return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);
};
